module.exports = __webpack_public_path__ + "img/whats-new-12_cn.86d0884.jpg";